import { deepClone } from '~/utils/immutability'

export default (state, { payload: userData }) => ({
  ...state,
  user: deepClone({ ...state.user, ...userData }),
})
